import React from 'react'
import type {
  MembershipPageMember,
  MembershipViewSource,
} from '@dataTypes/membership.type'
import AddMemberModal from './AddMemberModal.component'
import './UpdateMembershipPlanModal.css'

type UpdateMembershipPlanModalProps = {
  open: boolean
  member?: MembershipPageMember | null
  onClose: () => void
  onUpdated?: (member?: MembershipViewSource) => void
}

const UpdateMembershipPlanModal: React.FC<UpdateMembershipPlanModalProps> = ({
  open,
  member,
  onClose,
  onUpdated,
}) => {
  return (
    <AddMemberModal
      open={open}
      mode="update"
      member={member}
      onClose={onClose}
      onAdded={onUpdated}
    />
  )
}

export default UpdateMembershipPlanModal
